import React from 'react'
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterThree from '../common/footer/FooterThree';
import { FiFacebook, FiInstagram } from "react-icons/fi";

import Separator from "../elements/separator/Separator";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import PortfolioOne from "../elements/portfolio/PortfolioOne";
import TestimonialOne from "../elements/testimonial/TestimonialOne";
import ContactOne from '../elements/contact/ContactOne';
import HeroCarousel from '../components/home/HeroCarousel';
import FAQData from '../data/home/FaqData.json';


const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://www.blackwave.augustow.pl/#business",
    name: "BlackWave",
    url: "https://www.blackwave.augustow.pl/",
    image: "https://www.blackwave.augustow.pl/images/bg/bg-image-15.webp",
    logo: "https://www.blackwave.augustow.pl/logo512.png",
    telephone: "+48668650693",
    email: "blackwave.augustow@gmail.com",
    description: "Wypożyczalnia łodzi motorowych TEXAS w Augustowie. Czarter motorówek na Jeziorze Białym Augustowskim i Jeziorze Necko, również ze sternikiem.",
    address: {
        "@type": "PostalAddress",
        addressLocality: "Augustów",
        addressRegion: "Podlaskie",
        addressCountry: "PL"
    },
    areaServed: [
        { "@type": "City", name: "Augustów" },
        { "@type": "Place", name: "Jezioro Białe Augustowskie" },
        { "@type": "Place", name: "Jezioro Necko" }
    ],
    sameAs: [
        "https://www.facebook.com/profile.php?id=61561259094203",
        "https://www.instagram.com/blackwave_augustow"
    ],
    makesOffer: [
        {
            "@type": "Offer",
            itemOffered: {
                "@type": "Service",
                name: "Wynajem łodzi motorowej TEXAS 575 BLACK w Augustowie",
                areaServed: "Augustów"
            }
        },
        {
            "@type": "Offer",
            itemOffered: {
                "@type": "Service",
                name: "Wynajem łodzi motorowej TEXAS 770 BLACK w Augustowie",
                areaServed: "Augustów"
            }
        }
    ]
};

const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQData.map(({ question, answer }) => ({
        "@type": "Question",
        name: question,
        acceptedAnswer: { "@type": "Answer", text: answer }
    }))
};


const DigitalAgency = () => {
    return (
        <>
            <SEO
                title="Wynajem motorówek Augustów | Jezioro Białe i Necko | BlackWave"
                description="Wynajem łodzi motorowych TEXAS w Augustowie. Czarter motorówek na Jeziorze Białym Augustowskim i Jeziorze Necko, także ze sternikiem. Sprawdź flotę BlackWave."
                canonicalPath="/"
                structuredData={[localBusinessSchema, faqSchema]}
                preloadImage="/images/bg/bg-image-15.avif"
                preloadType="image/avif"
            />
            <main className="page-wrapper blackwave-home">

                <HeaderTwo btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* Production hero carousel: lightweight, accessible and independent from legacy react-slick styles. */}
                <HeroCarousel />

                {/* Social Icons */}
                <div className="row mt--30 blackwave-home__social">
                    <div className="col-lg-12">
                        <ul className="social-icon social-default with-gradient">
                            <li><a target="_blank" rel="noopener noreferrer" aria-label="BlackWave na Facebooku" href="https://www.facebook.com/profile.php?id=61561259094203"><FiFacebook /></a></li>
                            <li><a target="_blank" rel="noopener noreferrer" aria-label="BlackWave na Instagramie" href="https://www.instagram.com/blackwave_augustow?igsh=bjFjcXV4aHJnYXh3"><FiInstagram /></a></li>
                        </ul>
                    </div>
                </div>
                {/* End Hero Area */}

                {/* Search-friendly introduction; the page H1 now lives in the hero. */}
                <Separator />
                <section className="container rn-section-gap blackwave-home__intro" aria-labelledby="charter-intro-title">
                    <h2 id="charter-intro-title" className="text-center mb--20">Czarter motorówek w sercu Augustowa</h2>
                    <p className="text-center mt--20 blackwave-home__lead">
                        BlackWave to lokalna wypożyczalnia łodzi motorowych w Augustowie. Oferujemy czarter motorówek TEXAS na Jeziorze Białym Augustowskim i Jeziorze Necko, z możliwością rejsu z doświadczonym sternikiem. Wybierz łódź, sprawdź parametry i skontaktuj się z nami, aby potwierdzić dostępny termin.
                    </p>
                </section>


                <Separator />
                <section className="container rn-section-gap blackwave-home__guide" aria-labelledby="blackwave-guide-title">
                    <div className="row row--30 align-items-start">
                        <div className="col-lg-7">
                            <h2 id="blackwave-guide-title">Wynajem motorówki w Augustowie — najważniejsze informacje</h2>
                            <p>
                                Flota BlackWave obejmuje łodzie TEXAS przeznaczone do komfortowych rejsów po augustowskich jeziorach.
                                TEXAS 575 BLACK mieści do 8 osób i jest napędzany silnikiem Yamaha 70 hp, a większy TEXAS 770 BLACK
                                mieści do 11 osób i posiada silnik Yamaha 200 hp. Obie jednostki oferujemy również z doświadczonym sternikiem.
                            </p>
                            <p>
                                Najczęściej wybierane akweny to Jezioro Białe Augustowskie i Jezioro Necko. Przed rejsem potwierdzamy termin,
                                wariant wynajmu i zasady użytkowania łodzi. W cenie wynajmu godzinowego, zgodnie z opisem oferty, uwzględnione są
                                kamizelki ratunkowe oraz paliwo potrzebne do poruszania się łodzią w okresie najmu.
                            </p>
                        </div>
                        <div className="col-lg-5 mt_md--30 mt_sm--30">
                            <div className="faq-box blackwave-home__facts">
                                <h3>BlackWave w skrócie</h3>
                                <ul>
                                    <li><strong>Lokalizacja:</strong> Augustów, woj. podlaskie</li>
                                    <li><strong>Akweny:</strong> Jezioro Białe Augustowskie i Jezioro Necko</li>
                                    <li><strong>Flota:</strong> TEXAS 575 BLACK i TEXAS 770 BLACK</li>
                                    <li><strong>Pojemność:</strong> do 8 lub 11 osób, zależnie od jednostki</li>
                                    <li><strong>Opcja:</strong> czarter z doświadczonym sternikiem</li>
                                    <li><strong>Kontakt:</strong> +48 668 650 693</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Portfolio */}
                <Separator />
                <section id="pricing" className="rwt-portfolio-area rn-section-gap blackwave-home__fleet">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="Wybierz łódź"
                                    description="Spędźcie niezapomniane chwile na wodach Augustowa z naszymi wyjątkowymi łodziami motorowymi.<br> Oferujemy czarter z doświadczonym sternikiem."
                                />
                            </div>
                        </div>
                        <PortfolioOne Column="col-md-6 col-12 mt--30 portfolio no-overlay" />
                    </div>
                </section>

                {/* FAQ Section */}
                <Separator />
                <section className="container rn-section-gap blackwave-home__faq" aria-labelledby="faq-title">
                    <h2 id="faq-title" className="text-center mb--20">Najczęściej zadawane pytania — wynajem motorówek Augustów</h2>
                    <div className="row">
                        {FAQData.map((faq, index) => (
                            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mt--20 d-flex">
                                <article className="faq-box blackwave-home__faq-card">
                                    <h5>{faq.question}</h5>
                                    <p>{faq.answer}</p>
                                </article>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Testimonials */}
                <Separator />
                <section className="rwt-testimonial-area rn-section-gap blackwave-home__reviews">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    title="Opinie naszych klientów"
                                    description="Sprawdź ostatnie rekomendacje od naszych gości."
                                />
                            </div>
                        </div>
                        <TestimonialOne  />
                    </div>
                </section>

                {/* Contact */}
                <section className="rwt-contact-area rn-section-gap blackwave-home__contact">
                    <div id="contact" className="container">
                        <div className="col-lg-12">
                            <SectionTitle
                                textAlign="text-center"
                                radiusRounded=""
                                subtitle=""
                                title="Kontakt"
                                description="Zadzwoń aby zapytać o termin."
                            />
                        </div>
                        <ContactOne />
                    </div>
                </section>

                <FooterThree />
            </main>
        </>
    )
}

export default DigitalAgency;
